import { useEffect } from 'react'
import { Banner, Benefits, HireSection, IndustryTrail, Technology } from '../../../components'
import { bannerData, hireData, webDesignData } from './data'

const Travel = () => {

  useEffect(() => {

    window.scrollTo(0, 0)

  }, [])

  return (
    <div className='pt-[70px]'>
      <div className='dark:bg-gray-900 transition-all duration-700'>
        <Banner data={bannerData} />
      </div>
      <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
        <HireSection data={hireData} />
      </div>
      <div>
        <IndustryTrail title1={'Address the growing technology demand'} />
      </div>
      <div className='dark:bg-gray-900 transition-all duration-700'>
        <Technology />
      </div>
      <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
        <Benefits data={webDesignData} />
      </div>
    </div>)
}

export default Travel